export const LEAD_INTERCEPTION = {
  title: "Lead Interception Without the Friction",
  body: "Most software forces you to change how you run your business. FractoLabs intercepts leads silently under your existing setup:",
  items: [
    { icon: "users", text: "Without hiring or managing 24/7 sales staff." },
    { icon: "code", text: "Without touching code or complex workflows." },
    { icon: "megaphone", text: "Without increasing your current ad budget." },
    { icon: "card", text: "Without credit cards, retainers, or long-term contracts." },
  ],
};
